module.exports = require("botpress-version-manager");


//////////////////
// WEBPACK FOOTER
// external "botpress-version-manager"
// module id = 2
// module chunks = 0